import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { number, object, string } from "yup";
import { useDispatch, useSelector } from "react-redux";
import { createChain, resetFilters } from "../redux/chainsSagas";
import { useError } from "../../../../hooks/useError";
import { MainModal } from "../../../../components/modal/MainModal";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import { ChainFilters } from "./ChainFilters";
import { ErrorList } from "../../../../components/ErrorList";

const schema = object({
  name: string().label("Name").required(),
  uid: number()
    .label("Uid")
    .typeError(({ label, type }) => `${label} must be a ${type}`)
    .min(-10000)
    .max(10000)
    .required(),
  organization_id: object().required("Please choose organization")
}).required();

export const Add = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();

  const { organizations, storeStatuses, isAddNewStoreDisabled } = useSelector(
    (state) => state.chains.commonSettings
  );

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting }
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      add_new_store: false,
      active_store_statuses: storeStatuses.filter(
        ({ id }) => id == "Setup" || id == "Active" || id == "Presale"
      )
    }
  });

  const close = () => {
    dispatch(resetFilters());
    onClose();
  };

  const { errors: serverErrors, status } = useError({ cb: close, sliceKey: "chains" });

  const onSubmit = async (data) => {
    dispatch(createChain(data));
  };

  const primaryButtonDisabled = isSubmitting || status == "pending";

  return (
    <>
      <MainModal
        isOpen={isOpen}
        onClose={close}
        parentSelector=".chains"
        headerText="Add Clubready Chain"
        headerCloseHandler={close}
        bodyClassName="main-popup-body"
        primaryButtonText="Save"
        primaryButtonDisabled={primaryButtonDisabled}
        primaryBtnHandler={handleSubmit(onSubmit)}
        secondaryBtnText="Cancel"
        secondaryBtnHandler={close}
        height="auto"
        width={900}
      >
        <form>
          <ChainFilters
            control={control}
            register={register}
            isAddNewStoreDisabled={isAddNewStoreDisabled}
            organizations={organizations}
            storeStatuses={storeStatuses}
          />

          {status === "pending" && <LoadingAnimation uiLoader />}
          <ErrorList errors={{ ...errors, ...serverErrors }} />
        </form>
      </MainModal>
    </>
  );
};
